import {useState} from 'react';
import {useSizeDOMWindow} from 'util/hooks/useSizeDOMWindow';

const ensureInVisibleArea = (position, size, minWidth, minHeight, windowSize) => {
	let {x, y} = position;
	let {width, height} = size;
	const windowWidth = windowSize.width - 1;
	const windowHeight = windowSize.height - 1;
	x = Math.max(x || 0);
	y = Math.max(y || 0);
	width = Math.min(width || minWidth || 5, windowWidth);
	height = Math.min(height || minHeight || 5, windowHeight);
	return {
		position: {
			x: Math.min(x, windowWidth - width),
			y: Math.min(y, windowHeight - height),
		},
		size: {
			width: Math.max(width, minWidth),
			height: Math.max(height, minHeight),
		},
	};
};

export const usePopup = (defaultPosition, defaultSize, minWidth, minHeight) => {
	const [position, setPosition] = useState(defaultPosition);
	const [size, setSize] = useState(defaultSize);
	const p = ensureInVisibleArea(position, size, minWidth, minHeight, useSizeDOMWindow());
	return {...p, setPosition, setSize};
};